export default "__VITE_ASSET__BboS8jpr__"